import { GetCalendarEventsMeta, GetCalendarEventsPayload } from 'types/store/GetCalendarEvents';
import { createAsyncReducer } from 'utils/Redux';

import { getCalendarEventsActions } from '../actions';

export default createAsyncReducer<GetCalendarEventsMeta, GetCalendarEventsPayload>(getCalendarEventsActions);
